export default __webpack_public_path__ + "static/media/lieferheld_background_l2.95907567.jpg";